<template>
    <div class="image-container">
        <img style="height: 80%" src="../assets/images/Logo_Bleu.png">
    </div>
</template>

<script>
export default {
    name: "LbrxLoginLogo",
}
</script>
<style scoped>
@media (max-width: 1200px) {
    .image-container {
        margin-top: 15vmin !important;
    }
}
.image-container {
    margin-top: 10vmin;
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>